import { ColCommon, ColProps } from "./interface";
import { useMemo } from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import { RowMedia } from "../interface";

const Col = (props: ColProps) => {
  const { children, span, order, md, xs, className, style, ...restProps } =
    props;

  const handleVars: [Record<string, any>, string[]] = useMemo(() => {
    const vars: Record<string, any> = {};
    const cls: string[] = [];

    const handleVarValue = (k: keyof ColCommon, v: any, key?: RowMedia) => {
      switch (k) {
        default:
          return "";
        case "span":
          if (!v) {
            cls.push(`col-${key ? `${key}-` : ""}hidden`);
          }
          return `${(v / 24) * 100}%`;
        case "order":
          return v;
        case "flex":
          return v;
      }
    };

    if (typeof span !== "undefined") {
      vars[`--col-span`] = handleVarValue("span", span);
    }
    Object.entries({
      md,
      xs,
    }).forEach(([key, value]) => {
      if (typeof value === "undefined") {
        return;
      }
      if (typeof value === "number") {
        if (!value) {
          cls.push(`col-hidden`);
        }
        vars[`--col-${key}-span`] = handleVarValue("span", value);
        return;
      }
      // obj
      Object.entries(value).forEach(([k, v]) => {
        if (typeof v === "undefined") {
          return;
        }
        vars[`--col-${key}-${k}`] = handleVarValue(
          k as keyof ColCommon,
          v,
          key as RowMedia
        );
      });
    });

    return [vars, cls];
  }, [md, span]);

  return (
    <div
      className={classNames(
        styles.container,
        {
          [styles.hidden]: handleVars[1].includes("col-hidden"),
          [styles[`md-hidden`]]: handleVars[1].includes("col-md-hidden"),
        },
        className
      )}
      style={{
        ...style,
        ...handleVars[0],
      }}
      {...restProps}
    >
      {children}
    </div>
  );
};

Col.displayName = "Col";

export default Col;
